import {req,importFile } from './axiosFun';
/**
 *用户管理
 */
// 查询用户分页
export const qryUserList = (params) => { return req("post", "/yishantong-ui/user/qryUserList", params) };

// 修改用户状态
export const upStatus = (params) => { return req("post", "/yishantong-ui/user/upStatus", params) };

// 修改用户数据
export const upUser = (params) => { return req("post", "/yishantong-ui/user/upUser", params) };








// WEBPACK FOOTER //
// ./src/api/userApi.js